<template>
  <h1>404</h1>
  <h3>The calculator you are looking for does not exist</h3>
</template>